import { initSplideCarousel } from '@/splide-carousel';
import { initCountUp } from '@/count-up';

/** sm breakpoint — matches Tailwind default. */
const SM_BREAKPOINT = 640;

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('.rmh-stats').forEach((block) => {
		initSplideCarousel(block, {
			autoWidth: true,
			gap: '1.25rem',
			mediaQuery: 'min',
			breakpoints: {
				[SM_BREAKPOINT]: {
					destroy: true,
				},
			},
		});

		initCountUp(block);
	});
});
